/**
 * @description format +33655555555 to 06 55 55 55 55
 * @param number
 * @example formatPhoneNumber("+33655555555")
 */
export const formatPhoneNumber = (number: string): string => {
  const preFormat = /.*(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})/
  const pattern = '0$1 $2 $3 $4 $5'
  return number.replace('+33', '').replace(preFormat, pattern)
}
